// extracted by mini-css-extract-plugin
export var buttonContainer = "_8i-1";
export var fontSizeSelect = "_8i-3";
export var formatSelect = "_8i-2";
export var formats = "_8i-4";
export var hidden = "_8i-5";
export var icon = "_8i-6";
export var select = "_8i-0";